import _ from 'lodash';
import { Container, Flexbox, Text, useResize } from '@morf/ui';
import { FC, memo } from 'react';
import { WeekdayDetailsProps } from './types';
import { WeekdayDetailsSlots } from './WeekdayDetailsSlots';
import { formatValueDateToMoment } from '../../../../../components/helpers/formatValueDateToMoment';
import { groupAvailabilitySlotsByWeekday } from './groupAvailabilitySlotsByWeekday';
import { useTheme } from '@morf/theming';

const WeekdayDetails: FC<WeekdayDetailsProps> = ({
  monthlyAvailabilitySlots,
  isLoading,
  weekday,
}) => {
  const theme = useTheme();

  const timeslots = useResize({
    columns: {
      xxl: 4,
      xl: 4,
      lg: 2,
      md: 2,
      sm: 2,
      xs: 1,
    },
  });

  const formattedDate = formatValueDateToMoment(weekday).format('ddd, MMMM D');

  const weekdayAvailabilitySlots = groupAvailabilitySlotsByWeekday(
    monthlyAvailabilitySlots,
    weekday
  );

  const isWeekdaySlotsEmptyAndNotStreaming =
    weekdayAvailabilitySlots.length === 0 && !isLoading;

  return (
    <Container borderType='borderTop' p={1.25}>
      {isWeekdaySlotsEmptyAndNotStreaming ? (
        <Flexbox justifyContent='flex-start' alignItems='center' gap={0.5}>
          <Text tag='h4'>{formattedDate}</Text>
          <Text tag='p2' color={theme.colors.text.muted}>
            No availability
          </Text>
        </Flexbox>
      ) : (
        <Flexbox direction='column' justifyContent='flex-start'>
          <Text tag='h4'>{formattedDate}</Text>
          <WeekdayDetailsSlots
            columns={timeslots.columns}
            isLoading={isLoading}
            weekdayAvailabilitySlots={weekdayAvailabilitySlots}
          />
        </Flexbox>
      )}
    </Container>
  );
};

export const MemoizedWeekdayDetails = memo(WeekdayDetails);
